import React from 'react';
import Grid from 'atoms/Layout/Grid/Grid';
import Stack from 'atoms/Layout/Stack/Stack';
import CheckCircleFilled from 'app/icons/Monospaced/CheckCircle/CheckCircleFilled';
import HeadingAndSupportingText from 'molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import { TypographyProps } from 'atoms/Typography/Typography';

interface BaseFormThankYouProps {
  alignment?: 'left' | 'center';
  heading?: TypographyProps;
  supportingText?: TypographyProps;
}

const BaseFormThankYou = ({
  alignment = 'left',
  heading,
  supportingText,
}: BaseFormThankYouProps): JSX.Element => {
  const isCenter = alignment === 'center';

  return (
    <Grid totalColumns={1}>
      <Stack
        direction='column'
        gap='spacing-md'
        align={isCenter ? 'center' : 'flex-start'}
        justify={isCenter ? 'center' : 'flex-start'}
      >
        <CheckCircleFilled width={48} />
        <HeadingAndSupportingText
          gap='spacing-sm'
          heading={{
            text: 'Thank You!',
            type: 'heading',
            size: 'sm',
            fontWeight: 'font-weight-semibold',
            textAlign: alignment,
            ...heading,
          }}
          supportingText={{
            text: 'Keep an eye on your inbox.',
            type: 'paragraph',
            size: 'lg',
            fontWeight: 'font-weight-regular',
            color: 'text-tertiary',
            textAlign: alignment,
            ...supportingText,
          }}
        />
      </Stack>
    </Grid>
  );
};

export default BaseFormThankYou;
